<template>
  <div :class="$root.theme">
    <Header :locale="locale"/>

    <div class="container has-text-centered m-6">
      <h3 v-html="$t('checkout.not_available')"></h3>
      <p><a href="https://gimmemore.com">{{ $t('error.click_here')}}</a>{{ $t('error.to_homepage') }}</p>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";

export default {
  components: { Header },
  props: {
    locale: { type: String, default: 'en' }
  },
  created() {
    this.$i18n.locale = this.locale;
  },
}
</script>

<style lang="scss" scoped>
.enneagram {
  height: 100vh;
}
</style>
